
const ExclamationYellow = () => {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_8403_11928)">
                <rect width="80" height="80" fill="white" fillOpacity="0.01" />
                <rect width="80" height="80" rx="40" fill="#FABD00" fillOpacity="0.12" />
                <g clipPath="url(#clip1_8403_11928)">
                    <g clipPath="url(#clip2_8403_11928)">
                        <path
                            d="M39.9998 20.75C41.2201 20.75 42.3459 21.3945 42.9646 22.4516L61.5271 54.0766C62.1544 55.1422 62.1544 56.457 61.5443 57.5227C60.9341 58.5883 59.7912 59.25 58.5623 59.25H21.4373C20.2084 59.25 19.0654 58.5883 18.4552 57.5227C17.8451 56.457 17.8537 55.1336 18.4724 54.0766L37.0349 22.4516C37.6537 21.3945 38.7794 20.75 39.9998 20.75ZM39.9998 31.75C38.8568 31.75 37.9373 32.6695 37.9373 33.8125V43.4375C37.9373 44.5805 38.8568 45.5 39.9998 45.5C41.1427 45.5 42.0623 44.5805 42.0623 43.4375V33.8125C42.0623 32.6695 41.1427 31.75 39.9998 31.75ZM42.7498 51C42.7498 49.4789 41.5209 48.25 39.9998 48.25C38.4787 48.25 37.2498 49.4789 37.2498 51C37.2498 52.5211 38.4787 53.75 39.9998 53.75C41.5209 53.75 42.7498 52.5211 42.7498 51Z"
                            fill="#FABD00"
                        />
                    </g>
                </g>
            </g>
            <defs>
                <clipPath id="clip0_8403_11928">
                    <rect width="80" height="80" fill="white" />
                </clipPath>
                <clipPath id="clip1_8403_11928">
                    <rect width="44" height="44" fill="white" transform="translate(18 18)" />
                </clipPath>
                <clipPath id="clip2_8403_11928">
                    <rect width="44" height="44" fill="white" transform="translate(18 18)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ExclamationYellow;
